import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.css'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {

  title: string = '';
  content: string = '';
  cancelButton: string = '';
  confirmButton: string = '';
  secondScreen: boolean = false;
  singleButton: boolean = false;


  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { screen: string; vesselMasterName?: string }) { }
  
  ngOnInit(): void {
    switch (this.data.screen) {
      case "delete_report":
        this.title = $localize`:@@deletereporttitle: Delete this report`;
        this.content = $localize`:@@deletereportcontent: Are you sure you want to delete this report? All data will be permanently lost`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@confirmbutton: Confirm`;
        break;
      case "delete_net":
        this.title = $localize`:@@deletenettitle: Delete this net`;
        this.content = $localize`:@@deletenetcontent: Are you sure you want to delete this net? All data will be permanently lost`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@confirmbutton: Confirm`;
        true;
        break;
      case "delete_vessel":
        this.title = $localize`:@@deletevesseltitle: Delete this vessel`;
        this.content = $localize`:@@deletevesselcontent: Are you sure you want to delete this vessel? All data will be permanently lost`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@confirmbutton: Confirm`;
        break;
        case "delete_logbook":
        this.title = $localize`:@@deletelogbooktitle: Delete this logbook`;
        this.content = $localize`:@@deletelogbookcontent: Are you sure you want to delete this logbook? All mappings of VRNs to this logbook will be deleted as well and all data will be permanently lost`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@confirmbutton: Confirm`;
        true;
        break;
      case "delete_vrn_lb_mapping":
        this.title = $localize`:@@deletemappingtitle: Delete this mapping`;
        this.content = $localize`:@@deletevrnmappingcontent: Are you sure you want to delete all mappings of logbooks linked to this VRN? All data will be permanently lost`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@confirmbutton: Confirm`;
        true;
        break;
        case "delete_fin_vrn_mapping":
        this.title = $localize`:@@deletemappingtitle: Delete this mapping`;
        this.content = $localize`:@@deletefinmappingcontent: Are you sure you want to delete this FIN to VRN mapping? All data will be permanently lost`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@confirmbutton: Confirm`;
        true;
        break;
      case 'autofill':
        this.title = $localize`:@@autofilltitle: Confirm autofill`;
        this.content = $localize`:@@autofillcontent: Are you sure you want to autofill location details?`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@confirmbutton: Confirm`;
        this.secondScreen = true;
        break;
      case 'privacyConfirm':
        this.title = $localize`:@@privacytitle: Do not show notice again`;
        this.content = $localize`:@@privacycontent: Would you like disable showing the privacy notice and harvester attestation for future logins?`;
        this.cancelButton = $localize`:@@cancelbuttonno: No`;
        this.confirmButton = $localize`:@@confirmbuttonyes: Yes`;
        this.secondScreen = true;
        break;
      case 'incomplete_reports':
        this.title = $localize`:@@incompletereportstitle: Delete incomplete reports`;
        this.content = $localize`:@@incompletereportscontent: This trip has incomplete reports. Are you sure you want to end your trip? All incomplete reports will be deleted.`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@confirmbutton: Confirm`;
        break;
      case 'register_logbook':
        this.title = $localize`:@@registerlogbooktitle: Register Logbook`;
        this.content = $localize`:@@registerlogbookcontent: Do you want to register this logbook?`;
        this.cancelButton = $localize`:@@cancelbuttonno: No`;
        this.confirmButton = $localize`:@@confirmbuttonyes: Yes`;
        this.secondScreen = true;
        break;
      case 'vessel_master_confirm':
        this.title = $localize`:@@vesselmastertitle: Vessel Master Confirmation`;
        const name        = this.data.vesselMasterName ?? '__________';
        this.content      = $localize`:@@vesselmastercontent:I, ${name}, attest that the information contained in this report is true and accurate to the best of my knowledge.`;
        this.cancelButton = $localize`:@@cancelbuttonno: No`;
        this.confirmButton = $localize`:@@confirmbuttonyes: Yes`;
        this.secondScreen = true;
        break;
      case 'edit_report':
        this.title = $localize`:@@editreporttitle: Edit Report`;
        this.content      = $localize`:@@editreportcontent: Any edits made will be sent to Archipelago who will be make the necessary changes in FOS. Edits are not directly sent to DFO. Are you sure you want to edit this report? `;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@confirmbutton: Confirm`;
        this.secondScreen = true;
        break;
      case 'missing_reports':
        this.title = $localize`:@@missingreportstitle: Missing Reports`;
        this.content      = $localize`:@@missingreportscontent: This trip has at least one day missing a report. Please complete a catch or pause report for every day of the trip. Do you want to continue anyway?`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@continuebutton: Continue`;
        this.secondScreen = true;
        break;
      case 'new_trip_incomplete_reports':
        this.title = $localize`:@@newtripincompletereportstitle: Delete incomplete reports`;
        this.content = $localize`:@@newtripincompletereportscontent: This trip has incomplete reports. By starting a new trip, all incomplete reports will be deleted. Do you want to continue?`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@confirmbutton: Confirm`;
        this.secondScreen = true;
        break;
      case 'duplicate_report_date':
        this.title = $localize`:@@duplicatereportdatetitle: Existing Report For This Date`;
        this.content      = $localize`:@@duplicatereportdatecontent: DFO has already confirmed a catch or pause report for this date. Only one catch or pause report per day is accepted, so this report will likely be rejected and returned as an error. Do you want to continue anyway?`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@continuebutton: Continue`;
        this.secondScreen = true;
        break;
      case 'resume_trip':
        this.title = $localize`:@@resumetriptitle: Resume this trip`;
        this.content      = $localize`:@@resumetripcontent: This trip will become your current trip and any trip you have open now will be moved to Past Trips. New reports you file will belong to this trip. Do you want to continue?`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@continuebutton: Continue`;
        this.secondScreen = true;
        break;
      case 'unconfirmed_reports':
        this.title = $localize`:@@unconfirmedreportstitle: Unconfirmed Reports`;
        this.content      = $localize`:@@unconfirmedreportscontent: One or more reports in this trip have not yet received a confirmation number from DFO (they are awaiting a response or have an error). Do you want to continue?`;
        this.cancelButton = $localize`:@@cancelbutton: Cancel`;
        this.confirmButton = $localize`:@@continuebutton: Continue`;
        this.secondScreen = true;
        break;
    }

  }


  confirmClck() {
    
    if (this.secondScreen) {
      this.dialogRef.close(true);
    } else {
      this.secondScreen = true;
      this.content = $localize`:@@delteconfirm: Are you absolutely certain you want to delete?`;
    }
  }
}
